import React from "react";

const SVG = ({
  style = {},
  fill = "none",
  stroke = "#000",
  width = "24",
  height = "24",
  className = "",
  viewBox = "0 0 24 24"
}) => (
  <svg
    width={width}
    height={height}
    style={style}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <circle cx="18" cy="5" r="2.5" stroke={stroke} strokeWidth="1.5" />
    <circle cx="6" cy="12" r="2.5" stroke={stroke} strokeWidth="1.5" />
    <circle cx="18" cy="19" r="2.5" stroke={stroke} strokeWidth="1.5" />
    <path d="M8.5 10.5L15.5 6.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M8.5 13.5L15.5 17.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default SVG;
